<template>
    <Button label="Novo" icon="pi pi-plus" @click="toInserir()" />
</template>

<script>
export default {
    methods: {
        toInserir() {
            this.$emit('onInserir');
        },
    },
};
</script>
